import { FunctionComponent } from 'react';
import { Slot } from './Slot';
import styles from './styles.module.scss';
import { RadioGroup } from '@cademy-ui/form';

export type Slot = {
    from: Date;
    to: Date;
};

export type SlotPickerProps = {
    slots: Slot[];
    onClick: (slot: Slot) => void;
    value: Slot | null;
    timezone?: string;
    locale?: string;
};

export const SlotPicker: FunctionComponent<SlotPickerProps> = ({
    slots,
    onClick,
    value,
    timezone,
    locale,
}) => {
    return (
        <RadioGroup<Slot> className={styles.slots} options={slots} onChange={onClick} value={value}>
            {({ option, isFocused, isSelected }) => {
                return (
                    <Slot
                        from={option.from}
                        isSelected={isSelected}
                        isFocused={isFocused}
                        timezone={timezone}
                        locale={locale}
                    />
                );
            }}
        </RadioGroup>
    );
};
